// src/helpers/rutaTramites.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "http://backretiro360.us-3.evennode.com";
const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

const debugUrl = (url, params) => console.log("👉 URL:", API.getUri({ url, params }));

export const getTramites = async (params = {}) => {
  const url = p("tramite"); // si tu backend usa /tramite (según index)
  debugUrl(url, params);

  const { data } = await API.get(url, { ...auth(), params });

  // soporta: { data:[...] } o { tramites:[...] } o array directo
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.tramites)) return data.tramites;
  if (Array.isArray(data)) return data;
  return [];
};